import {combineReducers} from 'redux';
import adBanners from  './adBannersReducer';
import flexibleForm from './flexibleFormReducer';

const rootReducer = combineReducers({
    adBanners, flexibleForm
});

export default rootReducer;